import { render, staticRenderFns } from "./AirflowAlerts.vue?vue&type=template&id=67185512&scoped=true&"
import script from "./AirflowAlerts.vue?vue&type=script&lang=js&"
export * from "./AirflowAlerts.vue?vue&type=script&lang=js&"
import style0 from "./AirflowAlerts.vue?vue&type=style&index=0&id=67185512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67185512",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VDataTable,VProgressCircular,VSimpleCheckbox,VSpacer})
